<template>
  <div class="home-dashboard">
    <!-- ==================== 统计卡片 ==================== -->
    <div class="stats-row">
      <div class="stat-card" v-for="card in statsCards" :key="card.label">
        <div class="stat-icon" :style="{ background: card.bg }">
          <i :class="card.icon"></i>
        </div>
        <div class="stat-body">
          <span class="stat-value">{{ card.value }}</span>
          <span class="stat-label">{{ card.label }}</span>
        </div>
      </div>
    </div>

    <!-- ==================== 主内容区 ==================== -->
    <div class="content-grid">
      <!-- 左列：公告 + 值班信息 -->
      <div class="grid-left">
        <!-- 公告 -->
        <el-card shadow="never" class="panel-card" :body-style="{ padding: '20px' }">
          <template #header>
            <div class="panel-header">
              <i class="el-icon-bell panel-header-icon"></i>
              <span>公告通知</span>
            </div>
          </template>
          <div v-if="notices.length" class="notice-list">
            <div v-for="(item, idx) in notices" :key="item.id" class="notice-item" :class="{ 'notice-first': idx === 0 }">
              <div class="notice-img-wrap">
                <img v-if="item.banner" :src="item.banner" :alt="item.title" class="notice-img" />
                <div v-else class="notice-img-placeholder">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </div>
              <div class="notice-text">
                <h4 class="notice-title">{{ item.title }}</h4>
                <p class="notice-content">{{ item.content }}</p>
              </div>
            </div>
          </div>
          <el-empty v-else description="暂无公告" :image-size="80" />
        </el-card>

        <!-- 值班信息 -->
        <el-card shadow="never" class="panel-card" :body-style="{ padding: '20px' }">
          <template #header>
            <div class="panel-header">
              <i class="el-icon-date panel-header-icon"></i>
              <span>值班信息</span>
            </div>
          </template>
          <el-table :data="dutyData" border stripe size="small" class="panel-table" empty-text="暂未安排值班">
            <el-table-column prop="shift_time" label="值班日期" min-width="110" />
            <el-table-column label="值班员" min-width="100">
              <template #default="{ row }">{{ row.user ? row.user.name : '-' }}</template>
            </el-table-column>
            <el-table-column label="角色" min-width="100">
              <template #default="{ row }">
                <el-tag v-if="row.user && row.user.roles && row.user.roles.length" size="small" type="primary">
                  {{ row.user.roles[0].title }}
                </el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>

      <!-- 右列：住院信息 + 派车信息 -->
      <div class="grid-right">
        <!-- 住院信息 -->
        <el-card shadow="never" class="panel-card" :body-style="{ padding: '20px' }">
          <template #header>
            <div class="panel-header">
              <i class="el-icon-s-home panel-header-icon"></i>
              <span>住院信息</span>
            </div>
          </template>
          <el-table :data="inHospitalData" border stripe size="small" class="panel-table" empty-text="暂无住院记录">
            <el-table-column prop="hospitalized_time" label="住院时间" min-width="100" />
            <el-table-column label="姓名" min-width="80">
              <template #default="{ row }">{{ row.member ? row.member.realname : '-' }}</template>
            </el-table-column>
            <el-table-column prop="hospital" label="医院" min-width="100" />
            <el-table-column prop="department" label="科室" min-width="80" />
            <el-table-column prop="number" label="床位" min-width="60" align="center" />
            <el-table-column label="状态" min-width="80" align="center">
              <template #default="{ row }">
                <el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">
                  {{ inHospitalStatusDict[row.status] ? inHospitalStatusDict[row.status].label : '-' }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <!-- 派车信息 -->
        <el-card shadow="never" class="panel-card" :body-style="{ padding: '20px' }">
          <template #header>
            <div class="panel-header">
              <i class="el-icon-truck panel-header-icon"></i>
              <span>派车信息</span>
            </div>
          </template>
          <el-table :data="dispatchData" border stripe size="small" class="panel-table" empty-text="暂无派车记录">
            <el-table-column label="车辆" min-width="80">
              <template #default="{ row }">{{ row.car ? row.car.name : '-' }}</template>
            </el-table-column>
            <el-table-column prop="dispatch_time" label="派车时间" min-width="100" />
            <el-table-column prop="applicant" label="申请人" min-width="80" />
            <el-table-column prop="apply_time" label="申请时间" min-width="100" />
            <el-table-column prop="target" label="目的地" min-width="100" />
            <el-table-column prop="return_time" label="预计返回" min-width="100" />
          </el-table>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { getStatisticsDataAPI } from '@/api/home.js'
import { inHospitalStatusDict } from '@/utils/dict.js'

export default {
  name: 'index',

  data() {
    return {
      inHospitalStatusDict,
      notices: [],
      inHospitalData: [],
      dutyData: [],
      dispatchData: [],
      loading: true
    }
  },

  computed: {
    statsCards() {
      return [
        {
          label: '住院人数',
          value: this.inHospitalData.length,
          icon: 'el-icon-s-home',
          bg: 'linear-gradient(135deg, #667eea, #764ba2)'
        },
        {
          label: '今日派车',
          value: this.dispatchData.length,
          icon: 'el-icon-truck',
          bg: 'linear-gradient(135deg, #3b82f6, #60a5fa)'
        },
        {
          label: '今日值班',
          value: this.dutyData.length,
          icon: 'el-icon-date',
          bg: 'linear-gradient(135deg, #f97316, #fb923c)'
        },
        {
          label: '公告通知',
          value: this.notices.length,
          icon: 'el-icon-bell',
          bg: 'linear-gradient(135deg, #22c55e, #4ade80)'
        }
      ]
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      getStatisticsDataAPI()
        .then(res => {
          this.notices = res.announcement || []
          this.dispatchData = res.carApplication || []
          this.dutyData = res.duty || []
          this.inHospitalData = res.hospitalization || []
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
/* ==================== 整体布局 ==================== */
.home-dashboard {
  max-width: 1440px;
  margin: 0 auto;
}

/* ==================== 统计卡片 ==================== */
.stats-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: default;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon i {
  font-size: 24px;
  color: #fff;
}

.stat-body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.stat-label {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

/* ==================== 内容网格 ==================== */
.content-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.panel-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
  margin-bottom: 20px;
}

.panel-card /deep/ .el-card__header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafbfc;
}

.panel-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.panel-header-icon {
  font-size: 18px;
  color: #3b82f6;
}

.panel-table {
  width: 100%;
}

.panel-table /deep/ thead th {
  background: #f8fafc !important;
  color: #475569;
  font-weight: 600;
  font-size: 13px;
  border-color: #e2e8f0;
}

.panel-table /deep/ tbody td {
  font-size: 13px;
  color: #334155;
}

.panel-table /deep/ .el-table__empty-text {
  color: #94a3b8;
}

/* ==================== 公告列表 ==================== */
.notice-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: background 0.2s;
}

.notice-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.notice-item.notice-first {
  padding-top: 0;
}

.notice-img-wrap {
  flex-shrink: 0;
  width: 160px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  background: #f1f5f9;
}

.notice-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.notice-img-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 32px;
}

.notice-text {
  flex: 1;
  min-width: 0;
}

.notice-title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-content {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.7;
  text-indent: 2em;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ==================== 响应式 ==================== */
@media (max-width: 1200px) {
  .stats-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .content-grid {
    grid-template-columns: 1fr;
  }

  .stats-row {
    grid-template-columns: 1fr;
  }

  .notice-item {
    flex-direction: column;
  }

  .notice-img-wrap {
    width: 100%;
    height: 140px;
  }
}
</style>
